import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./ModalGallery.scss";

import { Image } from "../Image";

function GalleryImage({ src, alt, customClass, ...props }) {
  return (
    <Image
      src={src}
      alt={alt}
      customClass={cx(styles["gallery-image"], customClass)}
      {...props}
    />
  );
}

GalleryImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  customClass: PropTypes.string,
};

GalleryImage.defaultProps = {
  customClass: null,
};

GalleryImage.displayName = "ModalGallery.Image";

export default GalleryImage;
